// @flow
import { authenticatedFetch } from '../../../api/request';
import { deserializeNotifications } from './notificationsTransformer';

export default async function getNotifications() {
    const url = `/v5/notifications`;
    const response = await authenticatedFetch(url);
    return deserializeNotifications(response);
}
